export default __webpack_public_path__ + "static/media/E_wdt_c_cap_0.a483be87.mp3";